import React, { useEffect } from "react";
import { AppContext, User } from "../../../../context/appContext";
import axios from "axios";

import IApiState from "../interface/iApiState";
import IDashboardDTO from "../interface/iDashboardDTO";
import IRatingList from "../../../ratingOverview/interface/iRatingList";

export const WelcomeAdminContext = React.createContext<any>({});

const WelcomeAdminContextProvider = ({ children }: any): React.JSX.Element => {
  const {
    user,
    checkSession,
  }: {
    user: User;
    checkSession: (response: any) => void;
  } = React.useContext(AppContext);

  const [ratingList, setRatingList] = React.useState<IRatingList[]>([]);

  const [dashboardDTO, setDashboardDTO] = React.useState<IDashboardDTO>({
    appointments: {
      total: [],
      free: [],
      booked: [],
      speedcoaching: [],
    },
  });

  const apiState = React.useRef<IApiState>({
    loading: false,
    fetched: false,
  });

  const fetchDashboardData = React.useCallback(() => {
    axios
      .post(
        "https://bewerbungscoaching.wbstraining.de/api/service/admin/getAdminDashboardData.php",
        {
          sessionId: user.sessionId,
          date: "2025-06-05",
          limit: 5,
          coachId: null,
        }
      )
      .then((response) => {
        checkSession(response);

        dashboardDTO.appointments.free = response.data.free.data;
        dashboardDTO.appointments.booked = response.data.booked.data;
        dashboardDTO.appointments.speedcoaching =
          response.data.speedcoaching.data;

        response.data.lastRatings.length > 0 &&
          response.data.lastRatings.forEach(
            (rating: IRatingList) => (rating.expand = false)
          );

        setRatingList(response.data.lastRatings);

        apiState.current.loading = false;
        apiState.current.fetched = true;

        setDashboardDTO({ ...dashboardDTO });

        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error fetching coach list", error);
      });
  }, [checkSession, dashboardDTO, user.sessionId]);

  useEffect(() => {
    if (apiState.current.fetched) return;
    if (apiState.current.loading) return;

    apiState.current.loading = true;

    fetchDashboardData();
  }, [apiState, fetchDashboardData]);

  const value: {} = React.useMemo(
    () => ({
      ratingList,
      setRatingList,
      dashboardDTO,
      apiState,
    }),
    [dashboardDTO, ratingList]
  );

  return (
    <WelcomeAdminContext.Provider value={value}>
      {children}
    </WelcomeAdminContext.Provider>
  );
};

export default WelcomeAdminContextProvider;
